import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const GeneralSettings = lazyLoader(
  () => import("Containers/Settings/GeneralSettings/GeneralSetting")
);

export const GeneralSetting = () => {
  return (
    <Layout>
      <GeneralSettings />
    </Layout>
  );
};
